// extracted by mini-css-extract-plugin
export default {"select":"InvitationUserSelect-module__select--LMtgq","animatedBackground":"InvitationUserSelect-module__animatedBackground--Qia2h"};